import Vue from 'vue'
import Vuex from 'vuex'
import VueLocalStorage from 'vue-localstorage'

import mutations from './mutations'
import actions from './actions'
import getters from './getters'
import config from '@/config'

Vue.use(VueLocalStorage)
Vue.use(Vuex)

const initState = {
  isDebugMode: false,
  disabledUrl: '',

  formData: {
    titel: '',
    geschlecht: '',
    geburtstag: '',
    vorname: '',
    name: '',
    ort: '',
    plz: '',
    strasse: '',
    hausnummer: '',
    bundesland: '',
    telefon: '',
    name_ensembles: '',
    email: '',
    email_confirm: '',
    url: '',

    bank_vorname_name: '',
    bank_iban: '',
    bank_bic: '',

    hauptwohnsitz_deutschalnd: false,
    datei_reisepass: null,
    wahrnehmungsvertrag_gvl: false,
    wahrnehmungsvertrag_gvl_id: '',
    kuenstlersozialkasse: false,
    kuenstlersozialkasse_id: '',
    datei_kuenstlersozialkasse: null,
    berufsanfaenger: null,
    datei_berufsanfaenger_ausbildungsnachweis: null,
    datei_selbststaendigkeitsnachweis: null,
    gesamtbetrag_unter_60k: false,
    datei_gesamtbetrag_unter_60k: null,
    steuer_ident_nr: '',
    hauptberuf_bereich: '',
    freiberuflich_solo: false,
    nicht_jury: false,
    kein_stipendium: null,
    mit_stipendium: null,
    vita: '',
    konzerte_produktionen: '',
    url_referenz1: 'https://',
    url_referenz2: '',

    rechercheprojekte: '',
    kuenstlerisches_konzept: '',

    bestaetigung_angaben_korrekt: false,
    bestaetigung_finazbehoerden: false,
    bestaetigung_rechtsanspruch: false,
    bestaetigung_stammdaten_verwenden: false,
    bestaetigung_zustellung_dokumente: false,
    bestaetigung_datenschutz: false,
    bestaetigung_bundeshaushaltsordnung: false,
  },
  fileError: null,
  isFinished: false,
  isSignMode: false,
  isSigned: false,
  token: null
}

const getInitialState = () => {
  const excludekeys = [
    'datei_reisepass',
    'datei_kuenstlersozialkasse',
    'datei_berufsanfaenger_ausbildungsnachweis',
    'datei_selbststaendigkeitsnachweis',
    'datei_gesamtbetrag_unter_60k',
  ]
  const stateFromStorage = JSON.parse(Vue.localStorage.get(config.STORAGE_KEY, '{}'))
  const initState_ = JSON.parse(JSON.stringify(initState))

  Object.keys(initState_)
    .forEach(k => {
      if (!config.KEEP_LOGGED_IN || !stateFromStorage[k]) {
        return
      }

      if (k === 'formData') {
        Object.keys(initState_.formData).forEach(k_ => {
          if (!excludekeys.includes(k_)) {
            initState_.formData[k_] = stateFromStorage.formData[k_]
          }
        })
      } else {
        initState_[k] = stateFromStorage[k]
      }
    })

  // console.log('init state: ', initState_)
  return initState_
}

mutations.RESET = (state) => {
  Object
    .keys(initState)
    .map(key => {
      state[key] = initState[key]
    })

  if (config.KEEP_LOGGED_IN) {
    Vue.localStorage.set(config.STORAGE_KEY, JSON.stringify(state))
  }
}

mutations.RESET_FORM_DATA = (state) => {
  state.formData = {
    ...initState.formData
  }

  if (config.KEEP_LOGGED_IN) {
    Vue.localStorage.set(config.STORAGE_KEY, JSON.stringify(state))
  }
}

export default new Vuex.Store({
  plugins: [(store) => {
    store.subscribe((mutation, state) => {
      // can filter the mutation by mutation.type and mutation.payload
      if (config.KEEP_LOGGED_IN) {
        Vue.localStorage.set(config.STORAGE_KEY, JSON.stringify(state))
      }
    })
  }],

  state: getInitialState(),
  mutations,
  getters,
  actions
})
